<template>
  <base-dialog
    class="chart-filter-dialog"
    :visible="dialogVisible"
    border-radius="none"
    show-close
    @closed="close"
  >
    <template v-slot:header>
      <div class="font-h1">数据范围</div>
    </template>
    <div class="body" v-ps>
      <div class="body-row" v-if="!_.isEmpty(preConditions)">
        <div class="panel">
          <div class="panel-content">
            <div class="panel-content-row">
              <condition-list
                :conditions="preConditions"
                :search-sheet="searchSheet"
                :from="from"
                :canEdit="false"
                :rely-sheet="relySheetInfo"
                :disabled="from === 'chart_control'"
              ></condition-list>
            </div>
          </div>
        </div>
      </div>
      <div class="body-row">
        <div class="panel">
          <div class="panel-content">
            <div class="panel-content-row">
              <condition-list
                :conditions="conditions"
                ref="conditionList"
                :search-sheet="searchSheet"
                :from="from"
                :rely-sheet="relySheetInfo"
                :canEdit="from !== 'chart_control'"
                :disabled="from === 'chart_control'"
              ></condition-list>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-slot:footer>
      <base-button @click="close">取消</base-button>
      <base-button type="primary" @click="submit">确认</base-button>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import ConditionList from "@/components/UIComponents/ConditionList/ConditionList"
import BaseButton from "@/components/UIComponents/Button"
import { verifyCondition } from "@/utils/sheet"

export default {
  name: "chart-filter",
  components: {
    BaseDialog,
    BaseButton,
    ConditionList
  },
  props: {
    conditionList: {
      type: Array,
      default: () => []
    },
    preConditionList: {
      type: Array,
      default: () => []
    },
    dialogVisible: Boolean,
    searchSheet: {
      type: Object,
      required: true,
      default: () => ({
        sheetId: null, // 搜索工作表ID
        controls: [] // 搜索控件列表
      })
    },
    relySheetInfo: Object,
    from: {
      type: String,
      default: "sheet_frontend" // sheet_frontend,sheet_backend,workflow_gateway,workflow_search
    }
  },
  watch: {
    conditionList: {
      immediate: true,
      handler() {
        this.conditions = this._.cloneDeep(this.conditionList) || []
      }
    },
    preConditionList: {
      immediate: true,
      handler() {
        this.preConditions = this._.cloneDeep(this.preConditionList) || []
      }
    }
  },
  data() {
    return {
      conditions: [], // 条件列表
      preConditions: [] // 查询条件列表
    }
  },
  methods: {
    submit() {
      let { result, msg } = verifyCondition("submit", this.conditions)
      if (!result) {
        this.$message.error(msg)
        return
      }
      this.$emit("submit", this._.cloneDeep(this.conditions), this._.cloneDeep(this.preConditions))
      this.close()
    },
    close() {
      this.$emit("close")
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-filter-dialog {
  display: flex;
  flex-flow: column;
  ::v-deep .el-dialog__body {
    padding: 0 !important;
    display: flex;
    flex-flow: column;
    flex: auto;
  }
  .body-row {
    padding: 0 24px;
    .panel {
      padding-bottom: 14px;
      .panel-title {
        font-weight: 600;
      }
      .panel-content {
        .panel-content-row {
          .font-main {
            margin-bottom: 6px;
          }
          .el-select {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
